import { render, staticRenderFns } from "./FancyDetails.vue?vue&type=template&id=5f7655da&"
import script from "./FancyDetails.vue?vue&type=script&lang=js&"
export * from "./FancyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/pp-weberbuero/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f7655da')) {
      api.createRecord('5f7655da', component.options)
    } else {
      api.reload('5f7655da', component.options)
    }
    module.hot.accept("./FancyDetails.vue?vue&type=template&id=5f7655da&", function () {
      api.rerender('5f7655da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/FancyDetails.vue"
export default component.exports